<template>
  <div>
    <img class="ip-top" src="@/assets/infoPublic/images/ip-top@2x.png" />
    <div class="ip-box">
        <div class="ip-box-div">
            <img src="@/assets/infoPublic/images/1@2x.png" />
            <input ref="referenceUpload"
                  type="file"
                  multiple
                  name="myPhoto"
                  @change="photoRelease($event)"
                  id="referenceUpload"
                  onfocus="this.blur()"
                  style="position:absolute;top:0px;left:0px;width:100%;height:100%;opacity:0;" />
        </div>
        <div class="ip-box-div">
            <img src="@/assets/infoPublic/images/2@2x.png" />
            <input ref="referenceUpload"
                  type="file"
                  name="myVideo"
                  accept="video/*"
                  @change="videoRelease($event)"
                  id="referenceUpload"
                  onfocus="this.blur()"
                  style="position:absolute;top:0px;left:0px;width:100%;height:100%;opacity:0;" />

        </div>
        <div class="ip-box-div" @click="noticeRelease">
            <img src="@/assets/infoPublic/images/3@2x.png" />
        </div>
        <div class="ip-box-div" @click="taskRecord">
            <img src="@/assets/infoPublic/images/4@2x.png" />
        </div>
        <SenVideo :videoUrl="videoUrl" :videoUrlUp="videoUrlUp" :fileSize="fileSizeUp" :isShowVideo="isShowVideo" @listenToChildClose="close" />
    </div>
  </div>
</template>
<script>
import SenVideo from './SendVideo.vue';
export default {
  name: "classCardInfoSend",
  components:{
    SenVideo
  },
  data() {
    return {
      filesUrls:[],
      isShowVideo:false,
      videoUrl:'',
      videoUrlUp:'',
      fileSizeUp:0
    };
  },
  methods: {
    close(){
      this.isShowVideo=false
    },
    // 发布照片
    photoRelease(event){
      var filesUrls = event.target.files;
      var imgMasSize = 1024 * 1024 * 10; // 10MB
      var totalSize = 0;
      if (filesUrls.length > 20) {
          this.xy.msgError("最多只能上传20张图片");
          return;
      }
      for (var i = 0; i < filesUrls.length; i++) {
        totalSize+=filesUrls[i].size
        if (['jpeg', 'png', 'bmp', 'jpg'].indexOf(filesUrls[i].type.split("/")[1]) < 0) {
          // 自定义报错方式
          this.xy.msgError('文件类型仅支持 jpeg/png/jpg/bmp');
          return;
        }
        if (filesUrls[i].size > imgMasSize) {
          // 文件大小自定义限制
          this.xy.msgError('文件大小不能超过10MB');
          return;
        }
      }
      if(totalSize>(1024 * 1024 * 20)){
        this.xy.msgError("图片总大小不能超过20MB");
        return; 
      }
      // 跳转页面
      if (filesUrls.length > 0 || filesUrls.length <= 20) {
           this.$store.commit('infoPublic/setPicfilesUrls', filesUrls);
           this.$router.push('/home/SendPic');
      }
    },
    // 发布视频
    videoRelease(){
      var filesUrls = event.target.files;
      var imgMasSize = 524288000; // 500MB
      if (['mp4', 'quicktime'].indexOf(filesUrls[0].type.split("/")[1]) < 0) {
          // 自定义报错方式
            this.xy.msgError('文件类型仅支持 mp4，mov');
          return;
      }
      if (filesUrls[0].size > imgMasSize) {
          // 文件大小自定义限制
            this.xy.msgError('文件大小不能超过500MB');
          return;
      }

      // 跳转页面
      if (filesUrls !== "") {
          this.filesUrls=filesUrls
          console.log(this.filesUrls)
          this.upload(this.filesUrls)
          //this.$router.push('/home/SendVideo');
      }
    },
    // 上传优化
    upload (files) {
        console.log(files)
        let upData = []
        for (let item of files) {
        upData.push({
            UploadFile: item.name,
            UploadFileSize: item.size
        })
        }
        let params = {}
        params = {
            Data: upData,
            BussinessStr: ''
        }
        this.xyapi.post(this.$store.state.apiPath + '/api/Resource/UploadVideoVerifiCation', params).then(res => {
        if (res.success) {
            this.uploadFunc(files, res.data.result.Data)
        }
        })
    },
    uploadFunc (filesUrls, callbackData) {
        console.log(filesUrls, callbackData)
        let forNum = 0
        for (let i = 0, len = filesUrls.length; i < len; i++) {
        // put中的三个参数url，data，header中的type
        this.xyapi.$put(callbackData[i].UpLoadAddress, filesUrls[i], `${filesUrls[i].type}`).then(res=>{
          forNum++
          if (forNum === filesUrls.length) {
            let dataList = []
            for (let i = 0, len = callbackData.length; i < len; i++) {
              dataList.push({
              UploadFile: callbackData[i].UploadFileNames,
              UploadFileSize: filesUrls[i].size
              })
              this.videoUrl=callbackData[i].UpLoadAddress.substring(0, callbackData[i].UpLoadAddress.indexOf("?"))
            }
            this.UploadOk(dataList)// 保存数据(最终生成的需要提交的数据格式)
          }
        }).catch(err => {
            if (err.message.indexOf('403') !== -1) {
            this.xy.msgError('服务器出错，上传失败，请联系管理员。')
            return false
            }
        })
        }
    },
    UploadOk (list) {
      console.log(list,111)
      this.videoUrlUp = list[0].UploadFile
      this.fileSizeUp = list[0].UploadFileSize
      this.isShowVideo = true
    },
    sendVideoFunc(){
      let formData = new FormData();
        for (let i = 0; i < this.filesUrls.length; i++) {
          // append 文件
          formData.append("file", this.filesUrls[i])
      }
      this.xy.loading('视频上传中')
      this.xyapi.uploadPost(`${this.xyWebUrl}${this.xyUploadUrl}?uploadSubPath=ResourceVideo/${localStorage.getItem('accountId')}&token=${this.xyUploadToken}`, formData).then(res=>{
        if(res.code===1){
          this.isShowVideo=true
        }
        this.xy.unloading()
      });

    },
    // 发布通知
    noticeRelease(){
      // 跳转页面
      this.$router.push('/home/Notice')
    },

    // 任务记录
    taskRecord(){
      // 跳转页面
      // PublishTake
      this.$router.push('/home/PublishTake')
    }
  }
}
</script>
<style lang="less" scoped>
.ip-top {
    width:100%;
}

.ip-box {
    width:89%;
    margin:0 auto;
    margin-top:-30px;
}
    .ip-box > .ip-box-div {
        width:100%;
        margin-bottom:22px;
        position:relative;
    }
        .ip-box > .ip-box-div > img {
            width: 100%;
        }
</style>
